import { combineReducers } from 'redux';
import attorneyCreateReducer from 'store/reducers/attorney.create';
import attorneyList from 'store/reducers/attorney.list';
import attorneyRevokeReducer from 'store/reducers/attorney.revoke';
import certificate from 'store/reducers/certificates';
import auth from 'store/reducers/auth.reducer';
import dataForm from 'store/reducers/data-form';
import inviteList from 'store/reducers/invite.list';
import { api } from './api/base';
import inviteConteragentReducer from './reducers/invite.conteragent';
import powerAttorney from './reducers/power-attorney';
import sublicenseContractReducer from './reducers/sublicense-contract.reducer';

// Form blobs (dataForm, powerAttorney, invite.conteragent, sublicense, attorney.*)
// hold cross-route draft/invite state. Formik is local UI; these stay in Redux.
export const rootReducer = combineReducers({
  auth,
  [api.reducerPath]: api.reducer,
  dataForm,
  inviteList,
  certificate,
  attorneyList,
  powerAttorney,
  attorneyCreateReducer,
  attorneyRevokeReducer,
  inviteConteragentReducer,
  sublicenseContractReducer,
});

export const resetApiState = () => (dispatch: any) => {
  dispatch(api.util.resetApiState());
};
